<div class="secret-state" [class.secret-state--editing]="isEditing">
  <span class="secret-state__icon" aria-hidden="true">
    <app-svg-icon src="icon/lock.svg"/>
  </span>

  <span class="secret-state__text">
    <span class="secret-state__title">{{ field.label }}</span>

    <!--
      role="status" annuncia il passaggio da "Impostata" a "Inserisci la nuova
      password…" senza spostare il focus, che resta sul pulsante.
    -->
    <span class="secret-state__status" role="status">{{ statusText }}</span>
  </span>

  <button
    type="button"
    class="secret-state__action"
    [class.secret-state__action--cancel]="isEditing"
    [attr.aria-label]="buttonAriaLabel"
    (click)="toggle()"
  >
    {{ buttonLabel }}
  </button>
</div>
